import { Modal, Button } from 'src/components/design-system';
import styles from './recurring-scope-modal.module.scss';

// Scope prompt for a recurring event: "This event and all future occurrences"
// vs "Only this event", plus Cancel. `danger` styles it for delete flows.
export function RecurringScopeModal({
  open,
  title,
  message,
  lang,
  danger = false,
  loading = false,
  onOnlyThis,
  onAllFuture,
  onCancel,
}) {
  const scopeType = danger ? 'danger' : 'default';
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      width={400}
      loading={loading}
      maskClosable={!loading}
      closable={false}
      title={null}
      footer={null}
      className={styles.modal}>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <Button block type={scopeType} onClick={onAllFuture} disabled={loading}>
            {lang.SCOPE_THIS_AND_FUTURE}
          </Button>
          <Button block type={scopeType} onClick={onOnlyThis} disabled={loading}>
            {lang.SCOPE_ONLY_THIS}
          </Button>
        </div>
        <Button type="link" onClick={onCancel} disabled={loading}>
          {lang.CANCEL}
        </Button>
      </div>
    </Modal>
  );
}
